import Vue from "vue";
import { Notify } from "vant";
import axios from "axios";
//import store from './store'
import getToken from "./plugs/token";

Vue.use(Notify);
const service = axios.create({
  baseURL: process.env.VUE_APP_SXURL, // url = base url + request url
  //baseURL: process.env.VUE_APP_SXURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  async config => {
    // do something before request is sent
    let token = await getToken();
    console.log('token.jwt', token, token.jwt)
    config.headers["token"] = token.jwt;

    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 200, it is judged as an error.
    if (res.code && res.code !== "Success") {
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  async error => {
    console.log("err", error.response); // for debug
    let err = error.response ? error.response.data : error;
    Notify({ type: "warning", message: err.message || "Error!" });
    if (err.code == "TokenInvalidError") {
      // 重新获取Token
      let token = await getToken(true);
      console.log('token',token)
      //location.reload();
    }
    return Promise.reject(err);
  }
);

export default service;
